import { __rest } from "tslib";
import React from 'react';
import VeltRecordingPreviewStepsDialogAudioWireframe from './VeltRecordingPreviewStepsDialogAudioWireframe/VeltRecordingPreviewStepsDialogAudioWireframe';
import VeltRecordingPreviewStepsDialogVideoWireframe from './VeltRecordingPreviewStepsDialogVideoWireframe/VeltRecordingPreviewStepsDialogVideoWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltRecordingPreviewStepsDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecordingPreviewStepsDialogWireframe.Video = VeltRecordingPreviewStepsDialogVideoWireframe;
VeltRecordingPreviewStepsDialogWireframe.Audio = VeltRecordingPreviewStepsDialogAudioWireframe;
export default VeltRecordingPreviewStepsDialogWireframe;
